var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"owl-usage-measures-bar-chart tw-font-sans"},[(!_vm.isLoading)?_c('bar-chart',{attrs:{"id":_vm.chartId,"options":_vm.chartOptions,"callback":_vm.controls}}):_c('owl-loading-indicator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }